import loadable from '@loadable/component';
import FullPageLoading from '../../../components/Loading/FullPageLoading';
import { THERAPIST_ROUTES_PREFIX } from '../../therapist-planning/therapist-planning.path';

export const T_CHALLENGE_PACKS_PATH = `${THERAPIST_ROUTES_PREFIX}/challenge-packs`;

export const ChallengePacksLazy = loadable(async () => import('./challenge-packs.view'), {
  fallback: <FullPageLoading />,
});

export const T_SERIAL_CHALLENGE_PACKS_PATH = `${THERAPIST_ROUTES_PREFIX}/serial-challenge-packs`;

